import WhoIsWatching from './WhoIsWatching'

export default WhoIsWatching
// eslint-disable-next-line import/export
export * from './WhoIsWatching'
